<div
  class="group flex items-center pl-1 ml-2 mt-1 hover:bg-gray-100 active:bg-gray-200 active:scale-[0.97] rounded-xl py-2 mr-5 text-secondary-text hover:text-dark-text transition-all duration-100 cursor-pointer select-none"
>
  <div
    class="w-[35px] h-[35px] bg-white group-hover:bg-primary rounded-2xl flex items-center justify-center transition-colors duration-200"
  >
    <svg-icon
      [src]="'assets/icons/' + icon + '.svg'"
      [svgStyle]="{ 'width.px': 30, fill: '#345585' }"
      class="block group-hover:hidden transition-opacity duration-200"
    ></svg-icon>

    <svg-icon
      [src]="'assets/icons/' + icon + '.svg'"
      [svgStyle]="{ 'width.px': 30, fill: '#ffffff' }"
      class="hidden group-hover:block transition-opacity duration-200"
    ></svg-icon>
  </div>
  <p class="ml-2 font-bold">
    {{ label }}
  </p>
</div>
